<!-- =========================================================================================
  File Name: Coupon.vue
  Description: Coupon Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card class="mb-2" v-if="loaded">

      <div slot="no-body" class="tabs-container pl-6 py-3">
        <div class="w-full vx-row mb-2">
          <div class="vx-col w-3/12">
            <ejs-textbox floatLabelType="Auto" placeholder="Código" :enabled="editing" v-model="data_local.code" :change="data_local.code = data_local.code.trim().toUpperCase()"/>
          </div>
          <div class="flex vx-col w-9/12 items-center justify-end h-full">
            <div class="flex items-center justify-center w-48 h-12 mr-px rounded-sm bg-primary text-white cursor-pointer" @click="save" v-if="editing">
              <vs-icon icon-pack="feather" icon="icon-save" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Guardar cambios</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm border border-solid border-warning cursor-pointer" @click="reset_data" v-if="editing">
              <vs-icon icon-pack="feather" icon="icon-corner-up-left" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Cancelar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 mr-px rounded-sm bg-primary text-white cursor-pointer" @click="editing = true" v-if="!editing">
              <vs-icon icon-pack="feather" icon="icon-edit-2" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Editar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm bg-danger text-white cursor-pointer" @click="confirmDeleteRecord" v-if="!editing">
              <vs-icon icon-pack="feather" icon="icon-x" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Eliminar</div>
            </div>
          </div>
        </div>
        <div class="w-full vx-row">
          <div class="vx-col w-full">
            <ejs-textbox floatLabelType="Auto" placeholder="Nombre" :enabled="editing" v-model="data_local.name"/>
          </div>
        </div>
        <div class="w-full vx-row">
          <div class="vx-col w-1/3">
            <ejs-dropdownlist floatLabelType="Auto" placeholder="Tipo" highlight=true :dataSource="types" :fields="{text: 'value', value: 'id'}" v-model="data_local.typeId" :enabled="editing"/>
          </div>
          <div class="vx-col w-1/3">
            <ejs-dropdownlist floatLabelType="Auto" placeholder="Aplicación" highlight=true :dataSource="applications" :fields="{text: 'value', value: 'id'}" v-model="data_local.applicationId" :enabled="editing"/>
          </div>
          <div class="vx-col w-1/3">
            <ejs-dropdownlist floatLabelType="Auto" placeholder="Estado" highlight=true :dataSource="status" :fields="{text: 'value', value: 'id'}" v-model="data_local.statusId" :enabled="editing"/>
          </div>
        </div>
        <div class="w-full vx-row">
          <div class="vx-col w-1/3">
            <ejs-numerictextbox floatLabelType="Auto" :placeholder="data_local.typeId == 'P' ? 'Porcentaje' : 'Valor'" format="N2" :enabled="editing" textAlign='Right' v-model="data_local.value" :min="0"/>
          </div>
          <div class="vx-col w-2/3" v-if="data_local.applicationId != 'T'">
            <ejs-dropdownlist
              ref="product"
              floatLabelType="Auto"
              placeholder="Categoría"
              highlight=true
              v-model="data_local.categoryId"
              :dataSource="categories"
              :fields="{text: 'displayName', value: 'id'}"
              allowFiltering=true
              :filtering='categoryFiltering'
              :enabled="editing"
              v-if="data_local.applicationId == 'C'"
            />
            <ejs-dropdownlist
              ref="product"
              floatLabelType="Auto"
              placeholder="Producto"
              highlight=true
              v-model="data_local.productId"
              :dataSource="products"
              :fields="{text: 'searchField', value: 'id'}"
              allowFiltering=true
              :filtering='productFiltering'
              :enabled="editing"
              v-else
            />
          </div>
        </div>
        <div class="w-full vx-row items-center">
          <div class="vx-col" style="min-width: 650px;">
            <ejs-daterangepicker
              ref="period"
              floatLabelType="Auto"
              placeholder="Seleccione período de vigencia"
              v-model="period"
              :enabled="editing"
            >
              <e-presets>
                <e-preset label="Mes anterior" :start='lastMonthStart' :end='lastMonthEnd'></e-preset>
                <e-preset label="Mes actual" :start='currentMonthStart' :end='currentMonthEnd'></e-preset>
                <e-preset label="Año anterior" :start='lastYearStart' :end='lastYearEnd'></e-preset>
                <e-preset label="Año actual" :start='currentYearStart' :end='currentYearEnd'></e-preset>
              </e-presets>
            </ejs-daterangepicker>
          </div>
          <vs-spacer/>
          <div class="vx-col w-48">
            <ejs-checkbox label='Limitar cantidad' v-model="data_local.limit" :checked="data_local.limit" :disabled="!editing"/>
          </div>
          <div class="vx-col w-48" v-if="data_local.limit">
            <ejs-numerictextbox floatLabelType="Auto" placeholder="Cantidad de cupones" format="N0" :enabled="editing" textAlign='Right' v-model="data_local.quantity" :min="1"/>
          </div>
        </div>
        <div class="w-full vx-row">
          <div class="vx-col w-1/6">
            <ejs-numerictextbox floatLabelType="Auto" placeholder="Cupones redimidos" format="N0" :readonly="true" textAlign='Right' v-model="data_local.used"/>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
  import Vue from "vue";
  import {Query} from "@syncfusion/ej2-data";
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {NumericTextBoxPlugin} from "@syncfusion/ej2-vue-inputs";
  import {CheckBoxPlugin} from "@syncfusion/ej2-vue-buttons";
  import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";
  import {DateRangePickerPlugin} from '@syncfusion/ej2-vue-calendars';
  import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
  import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
  import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
  import numbers from 'cldr-data/main/es-GT/numbers.json';
  import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
  import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week
  import {firebase, db} from '@/firebaseConfig';

  Vue.use(TextBoxPlugin);
  Vue.use(NumericTextBoxPlugin);
  Vue.use(CheckBoxPlugin);
  Vue.use(DropDownListPlugin);
  Vue.use(DateRangePickerPlugin);

  loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);
  setCulture('es-GT');
  L10n.load({
    'es-GT': {
      'daterangepicker': {
        placeholder: 'Seleccione período',
        startLabel: 'Fecha inicial',
        endLabel: 'Fecha final',
        applyText: 'Seleccionar',
        cancelText: 'Cancelar',
        selectedDays: 'Seleccione día inicial y final',
        days: 'Días',
        customRange: 'Otro período'
      }
    }
  });

  export default {
    data() {
      return {
        loaded: false,
        editing: false,
        id: 0,
        applications: [{id: 'T', value: 'Todos los productos'}, {id: 'C', value: 'Una categoría de productos'}, {id: 'P', value: 'Un producto'}],
        types: [{id: 'P', value: 'Porcentaje'}, {id: 'V', value: 'Valor'}],
        status: [{id: 'ACT', value: 'Activo'}, {id: 'IN', value: 'Inactivo'}],
        productQuery: new Query().select(['searchField', 'id']).take(10),
        categoryQuery: new Query().select(['name', 'id']).take(10),
        data: null,
        data_local: {
          id: '',
          code: '',
          name: '',
          applicationId: 'T',
          typeId: 'P',
          statusId: 'ACT',
          value: 0,
          categoryId: 0,
          productId: 0,
          startDate: new Date(),
          endDate: new Date(),
          limit: false,
          quantity: 0,
          used: 0
        },
        period: null,
        id_not_found: false,
        currentYearStart: new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0),
        currentYearEnd: new Date(new Date().getFullYear(), 11, 31, 23, 59, 59, 999),
        lastYearStart: new Date(new Date().getFullYear() - 1, 0, 1, 0, 0, 0, 0),
        lastYearEnd: new Date(new Date().getFullYear() - 1, 11, 31, 23, 59, 59, 999),
        currentMonthStart: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        currentMonthEnd: new Date(),
        lastMonthStart: new Date(),
        lastMonthEnd: new Date()
      }
    },
    computed: {
      categories() {
        return this.$store.getters.categoriesList;
      },
      products() {
        return this.$store.getters.productsList;
      }
    },
    methods: {
      categoryFiltering: function (e) {
        const searchData = JSON.parse(JSON.stringify(this.categories));
        if (e.text == '') {
          e.updateData(searchData);
        } else {
          let query = new Query().select(['name', 'id']);
          query = (e.text !== '') ? query.where('name', 'contains', e.text, true, true) : query;
          e.updateData(searchData, query);
        }
      },
      productFiltering: function (e) {
        const searchData = JSON.parse(JSON.stringify(this.products));
        if (e.text == '') {
          e.updateData(searchData);
        } else {
          let query = new Query().select(['searchField', 'id']);
          query = (e.text !== '') ? query.where('searchField', 'contains', e.text, true, true) : query;
          e.updateData(searchData, query);
        }
      },
      reset_data() {
        if (this.id > 0) {
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.period = [new Date(this.data.startDate.seconds * 1000), new Date(this.data.endDate.seconds * 1000)];
          this.editing = false;
          this.loaded = true;
        } else {
          this.$router.push({name: 'coupons'});
        }
      },
      getData(id) {
        if (id) {
          if (id == '0') {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
          } else {
            this.data = this.$store.getters.getCoupon(id);
            this.reset_data();
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
        }
      },
      validateForm() {
        let message = '';
        if (this.data_local.code.trim() == '') {
          message += `${(message == '' ? '' : '<br/>')}Debe especificar un código de cupón`;
        }
        if (this.data_local.name.trim() == '') {
          message += `${(message == '' ? '' : '<br/>')}Debe indicar un nombre`;
        }
        if (this.data_local.value <= 0) {
          message += `${(message == '' ? '' : '<br/>')}Debe especificar un valor mayor a cero`;
        }
        if (this.period == null) {
          message += `${(message == '' ? '' : '<br/>')}Debe seleccionar un período de vigencia`;
        }
        if (message != '') {
          this.$vs.notify({
            title: 'Error validando información',
            text: message,
            color: 'danger',
            time: 10000
          });
        }
        return (message == '');
      },
      updateList(list, newId) {
        const self = this;
        db.collection('catalogs').doc('coupons').update({list: list})
          .then(() => {
            self.$vs.notify({
              title: 'Información actualizada',
              text: 'Datos del cupón fueron actualizados correctamente',
              color: 'primary'
            });
            if (self.id == '0') {
              self.$router.push({name: 'coupon', params: {id: newId}});
            }
            self.editing = false;
            self.$vs.loading.close();
          })
          .catch((error) => {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: error.message,
              color: 'danger'
            });
            self.$vs.loading.close();
          })
      },
      save() {
        if (this.validateForm()) {
          this.$vs.loading({
            text: 'Guardando información de cupón',
            type: 'point'
          });
          if (['T', 'C'].includes(this.data_local.applicationId == 'T')) {
            this.data_local.productId = 0;
          }
          if (['T', 'P'].includes(this.data_local.applicationId == 'T')) {
            this.data_local.categoryId = 0;
          }
          this.data_local.startDate = firebase.firestore.Timestamp.fromDate(this.period[0]);
          this.data_local.endDate = firebase.firestore.Timestamp.fromDate(this.period[1]);
          const list = [...this.$store.getters.couponsList];
          if (this.data_local.id > 0) {
            const index = list.findIndex(i => i.id === this.data_local.id);
            if (index >= 0) {
              list[index] = JSON.parse(JSON.stringify(this.data_local));
              this.updateList(list, this.data_local.id);
            }
          } else {
            const self = this;
            db.collection('catalogs').doc('coupons').update({sequence: firebase.firestore.FieldValue.increment(1)})
              .then(() => {
                const data = {...this.data_local};
                db.collection('catalogs').doc('coupons').get()
                  .then(doc => {
                    if (doc.exists) {
                      const newId = doc.data();
                      data.id = newId.sequence.toString();
                      list.push(data);
                      self.updateList(list, data.id);
                    }
                  })
              });
          }
        }
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a eliminar cupón "${this.data.name}"`,
          accept: this.deleteRecord,
          acceptText: "Delete"
        })
      },
      deleteRecord() {
        this.$vs.loading({
          text: 'Eliminando cupón',
          type: 'point'
        });
      }
    },

    mounted() {
      this.id = this.$route.params.id;
      const self = this;
      setTimeout(function () {
        self.getData(self.id);
      }, 750);
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
</style>
